import React from 'react';
import { PlayerAvatar } from './PlayerAvatar';

export const MinPlayerCard = React.memo(({ playerPos, onSelect }) => {
  const { player, eligibility, is_captain, jersey_number } = playerPos;
  const isInactive = !eligibility.eligible || eligibility.isExpelled || eligibility.isSubstituted;
  const hasYellowCard = eligibility.yellowCards > 0;
  const fullName = `${player?.first_name || ''} ${player?.last_name || ''}`.trim() || 'Unknown';

  return (
    <div
      onClick={isInactive ? undefined : () => onSelect(playerPos)}
      className={`
        relative flex flex-col items-center p-3 rounded-xl
        bg-gray-800/80 border border-gray-700
        transition-all
        ${isInactive
          ? 'opacity-30 cursor-default'
          : 'cursor-pointer hover:bg-gray-700/80 hover:border-gray-500 active:scale-[0.97]'
        }
      `}
    >
      {/* Badges - top right corner */}
      <div className="absolute top-1.5 right-1.5 flex items-center gap-1">
        {is_captain && (
          <div className="w-5 h-5 flex items-center justify-center bg-amber-600 text-white text-[10px] font-bold rounded">
            C
          </div>
        )}
        {hasYellowCard && !isInactive && (
          <div className="w-3 h-4 bg-yellow-400 rounded-sm" />
        )}
        {eligibility.isExpelled && (
          <div className="w-3 h-4 bg-red-500 rounded-sm" />
        )}
      </div>

      {/* Photo */}
      <PlayerAvatar player={player} jerseyNumber={jersey_number} size={80} />

      {/* Name */}
      <div className={`mt-2 text-sm font-medium text-white text-center truncate w-full ${isInactive ? 'line-through' : ''}`}>
        {fullName}
      </div>

      {/* Jersey Number */}
      <div className="text-xs text-gray-400 font-mono mt-0.5">
        #{jersey_number}
      </div>

      {/* Status badge */}
      {eligibility.isSubstituted && (
        <div className="mt-1 px-2 py-0.5 bg-blue-900/50 text-blue-400 text-[10px] font-bold rounded">
          SUB
        </div>
      )}
      {eligibility.isExpelled && (
        <div className="mt-1 px-2 py-0.5 bg-red-900/50 text-red-400 text-[10px] font-bold rounded">
          OUT
        </div>
      )}
    </div>
  );
});

MinPlayerCard.displayName = 'MinPlayerCard';
